import { render, staticRenderFns } from "./pcModule3.vue?vue&type=template&id=04f7a448&scoped=true"
import script from "./pcModule3.vue?vue&type=script&lang=js"
export * from "./pcModule3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f7a448",
  null
  
)

export default component.exports